import {SelectBox} from "devextreme-react/select-box";
import {RequiredRule, Validator} from "devextreme-react/validator";
import {useContext} from 'react';
import {useGetCompanyUsers} from '../../../../api/users';
import {DateWithTimeframeBox} from '../../../../components';
import {useAuth} from '../../../../contexts/auth';
import {Field, Panel} from '../../../../layouts';
import {AR, OrderStatus} from '../../../../types/enums';
import {TimeframeType} from '../../../../utils/date-utils';
import {WorkOrderContext} from '../context/WorkOrderContext';

export default function ScheduleDatePanel() {

	const { order, modifyOrder } = useContext(WorkOrderContext);

	const isOrderReadonly =
		order.details.orderStatusID === OrderStatus.Closed ||
		order.details.orderStatusID === OrderStatus.Cancelled ||
		order.details.orderStatusID === OrderStatus.Pending;

	const dateReadOnly = !order.details.activeARs.includes(AR.WOCfiToScheduleAppointment) || isOrderReadonly;

	let dateRequired = !dateReadOnly;

	let technicianReadOnly = dateReadOnly;

	const { user } = useAuth();
	const companyUsers = useGetCompanyUsers(user?.companyId!);

	return (
		<Panel header={'Dates'} >

			<Field label="Scheduled Date">
				<DateWithTimeframeBox value={order.details.scheduledDate}
					timeframeType={TimeframeType.Long}
					timeRequired={true}
					onValueChanged={(e) => modifyOrder({ ...order.details, scheduledDate: e.value })}
					readOnly={dateReadOnly}
					className={dateRequired ? 'required' : ''}
					min={!dateReadOnly ? new Date() : undefined}>
					<Validator>
						{dateRequired && order.modified &&
							<RequiredRule message={'Scheduled Date is required'} />}
					</Validator>
				</DateWithTimeframeBox>
			</Field>
			<Field label={'Technician'}>
				<SelectBox
					value={order.details.technician}
					showClearButton={true}
					readOnly={technicianReadOnly}
					valueExpr={'userName'}
					displayExpr={'fullName'}
					onValueChanged={(e) => modifyOrder({ ...order.details, technician: e.value })}
					dataSource={companyUsers?.data.filter(x =>
						(x.groups?.includes('Installer') || x.groups?.includes('Measure/Template') || x.groups?.includes('Technician')) &&
						(!x.inactive || x.userName === order.details.technician))} />
			</Field>
		</Panel>
	);
}
